import * as React from "react";
import { LineGL } from "../LineGL";
import { ObjectType } from "../interfaces/object";
import { LineStyle } from "../interfaces/element";
import { DashLineGL } from "../DashLineGL";
import { hexColor } from "../helpers/colorParser";
import { Vertical } from "./Vertical";
import { VerticalBand } from "./VerticalBand";
import memoize from "memoize-one";
import { Horizontal } from "./Horizontal";
import { Polygon } from "./Polygon";
import { ErrorBar } from "./ErrorBar";
export class ObjectGL extends React.Component {
    constructor() {
        super(...arguments);
        this.getXY = memoize(getXY);
    }
    render() {
        const { grafosObject, xMapper, yMapper, domainX, domainY } = this.props;
        const xy = this.getXY(grafosObject, xMapper, yMapper);
        switch (grafosObject.type) {
            case ObjectType.horizon:
                return grafosObject.coords.map((pos, index) => (React.createElement(Horizontal, { y: pos, key: index, show: true, thickness: grafosObject.lineWidth, domainY: domainY, color: hexColor(grafosObject.color), yMapper: yMapper, style: grafosObject.lineStyle })));
            case ObjectType.vertical:
                return grafosObject.coords.map((pos, index) => (React.createElement(Vertical, { x: pos, key: index, show: true, thickness: grafosObject.lineWidth, domainX: domainX, color: hexColor(grafosObject.color), xMapper: xMapper, style: grafosObject.lineStyle })));
            case ObjectType.vband:
                return grafosObject.coords.map((_, index) => index % 2 ? (React.createElement(VerticalBand, { x: [grafosObject.coords[index], grafosObject.coords[index - 1]], key: index, show: true, thickness: grafosObject.lineWidth, domainX: domainX, xMapper: xMapper, color: hexColor(grafosObject.color), style: grafosObject.lineStyle })) : null);
            case ObjectType.polygon:
                return (React.createElement(Polygon, { key: this.props.key, show: true, fill: grafosObject.fillObject, thickness: grafosObject.lineWidth, domainX: domainX, domainY: domainY, style: grafosObject.lineStyle, color: hexColor(grafosObject.color), xy: xy }));
            case ObjectType.errorBar:
                return (React.createElement(ErrorBar, { key: this.props.key, show: true, thickness: grafosObject.lineWidth, domainX: domainX, domainY: domainY, style: grafosObject.lineStyle, color: hexColor(grafosObject.color), xy: xy }));
            default:
                return xy ? (grafosObject.lineStyle === LineStyle.solid ? (React.createElement(LineGL, { key: this.props.key, show: true, thickness: grafosObject.lineWidth, domainX: domainX, domainY: domainY, color: hexColor(grafosObject.color), xy: xy })) : (React.createElement(DashLineGL, { key: this.props.key, show: true, thickness: grafosObject.lineWidth, domainX: domainX, domainY: domainY, color: hexColor(grafosObject.color), xy: xy, style: grafosObject.lineStyle }))) : null;
        }
    }
}
export const getXY = (grafosObject, xMapper, yMapper) => {
    switch (grafosObject.type) {
        case ObjectType.line:
            return getLineXY(grafosObject, xMapper, yMapper);
        case ObjectType.oval:
            return getOvalXY(grafosObject, xMapper, yMapper);
        case ObjectType.polygon:
            return getPolygonXY(grafosObject, xMapper, yMapper);
        case ObjectType.errorBar:
            return getErrorBarXY(grafosObject, xMapper, yMapper);
        default:
            return null;
    }
};
export function getOvalXY(grafosObject, xMapper, yMapper) {
    const centerX = grafosObject.coords[0];
    const centerY = grafosObject.coords[1];
    const ovalA = grafosObject.coords[2];
    const ovalB = grafosObject.coords[3];
    const numCoordinates = 1000;
    const xy = new Float32Array(numCoordinates * 2 + 2);
    for (let index = 0; index < numCoordinates + 1; index++) {
        const angle = (index * 2.0 * Math.PI) / numCoordinates;
        xy[index * 2] = xMapper(ovalA * Math.cos(angle) + centerX);
        xy[index * 2 + 1] = yMapper(ovalB * Math.sin(angle) + centerY);
    }
    return xy;
}
export function getLineXY(grafosObject, xMapper, yMapper) {
    const numCoordinates = grafosObject.coords.length;
    const xy = grafosObject.coords.reduce((acc, item, index) => {
        acc[index] = index % 2 ? yMapper(item) : xMapper(item);
        return acc;
    }, new Float32Array(numCoordinates));
    return xy;
}
export function getPolygonXY(grafosObject, xMapper, yMapper) {
    const numCoordinates = grafosObject.coords.length + 2;
    const xy = grafosObject.coords.reduce((acc, item, index) => {
        acc[index] = index % 2 ? yMapper(item) : xMapper(item);
        return acc;
    }, new Float32Array(numCoordinates));
    xy[numCoordinates - 2] = xy[0];
    xy[numCoordinates - 1] = xy[1];
    return xy;
}
export function getErrorBarXY(grafosObject, xMapper, yMapper) {
    let errorBarProps;
    if (grafosObject.coordsString !== "") {
        errorBarProps = grafosObject.coordsString
            .replace(/\s/g, "")
            .split("$")
            .filter((item) => item)
            .reduce((acc, current, index) => (Object.assign(Object.assign({}, acc), { [current]: grafosObject.coords[index] })), {});
    }
    else {
        errorBarProps = {
            X_VALUE: grafosObject.coords[0],
            LOWER: grafosObject.coords[1],
            UPPER: grafosObject.coords[2],
            WIDTH: grafosObject.coords[3],
        };
    }
    const coords = [
        errorBarProps.X_VALUE - errorBarProps.WIDTH / 2,
        errorBarProps.UPPER,
        errorBarProps.X_VALUE + errorBarProps.WIDTH / 2,
        errorBarProps.UPPER,
        errorBarProps.X_VALUE,
        errorBarProps.UPPER,
        errorBarProps.X_VALUE,
        errorBarProps.LOWER,
        errorBarProps.X_VALUE - errorBarProps.WIDTH / 2,
        errorBarProps.LOWER,
        errorBarProps.X_VALUE + errorBarProps.WIDTH / 2,
        errorBarProps.LOWER,
    ];
    const numCoordinates = coords.length;
    const xy = coords.reduce((acc, item, index) => {
        acc[index] = index % 2 ? yMapper(item) : xMapper(item);
        return acc;
    }, new Float32Array(numCoordinates));
    return xy;
}
//# sourceMappingURL=index.js.map